"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("../../components/utils/helpers");
var _colors = require("../colors.config");
var _default = function _default(isFontBigger, isHighContrast) {
  return {
    '& .MuiPickersBasePicker-pickerView': {
      borderRadius: '0 0 12px 12px',
      borderTop: "1px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100))
    },
    '& .MuiPickersCalendarHeader-iconButton.Mui-disabled': {
      opacity: 0.4
    },
    '& .MuiPickersCalendarHeader-switchHeader': {
      padding: '0 16px'
    },
    '& .MuiPickersCalendarHeader-transitionContainer': {
      '& > p': {
        color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(200) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
        fontSize: isFontBigger ? 21 : 18,
        fontWeight: 300,
        lineHeight: '26px'
      },
      height: 26
    },
    '& .MuiPickersDay-day': {
      color: isHighContrast ? _colors.Black[50] : _colors.Black[500]
    },
    '& .MuiPickersDay-day.MuiPickersDay-dayDisabled': {
      opacity: 0.4
    },
    '& .MuiPickersDay-day.MuiPickersDay-daySelected': {
      color: 'white'
    },
    '& .MuiPickersMonth-root': {
      color: isHighContrast ? _colors.Black[50] : _colors.Black[500]
    },
    '& .MuiPickersMonth-root.MuiPickersMonth-monthDisabled': {
      opacity: 0.4
    },
    '& .MuiPickersMonth-root.MuiPickersMonth-monthSelected': {
      color: _helpers.agentDeveloperUtils.getPrimaryColor(450)
    },
    '& .MuiPickersToolbar-toolbar': {
      backgroundColor: 'transparent',
      height: 40,
      justifyContent: 'space-between',
      minHeight: 40,
      padding: '6px 28px'
    },
    '& .MuiPickersToolbarButton-toolbarBtn:nth-child(2) .MuiTypography-h4': {
      width: 85
    },
    '& .MuiPickersToolbarText-toolbarBtnSelected': {
      backgroundColor: _helpers.agentDeveloperUtils.getPrimaryColor(50),
      color: _helpers.agentDeveloperUtils.getPrimaryColor(450)
    },
    '& .MuiPickersToolbarText-toolbarTxt': {
      color: _helpers.agentDeveloperUtils.getPrimaryColor(450)
    },
    '& .MuiPickersYear-root': {
      color: isHighContrast ? _colors.Black[50] : _colors.Black[500]
    },
    '& .MuiPickersYear-root.MuiPickersYear-yearDisabled': {
      opacity: 0.4
    },
    '& .MuiPickersYear-root.MuiPickersYear-yearSelected': {
      color: _helpers.agentDeveloperUtils.getPrimaryColor(450)
    },
    '& .MuiPickersYearSelection-container': {
      height: 318
    },
    '& .MuiTypography-h4, & .MuiTypography-h6': {
      borderRadius: '14px',
      fontSize: isFontBigger ? 22 : 20,
      fontWeight: 400,
      lineHeight: '28px',
      width: 70
    },
    border: "1px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100)),
    borderRadius: '12px'
  };
};
exports.default = _default;